import React from 'react';

/** Общий с календарём наград (LobbyDailyRewardsScreen): монетный «дождь» + синтезаторный звук. */
let rewardAudioContext = null;

export function createCoinParticles(count = 22) {
  return Array.from({ length: count }).map((_, idx) => ({
    id: `${Date.now()}-${idx}`,
    left: Math.random() * 100,
    delay: Math.random() * 0.42,
    duration: 1.05 + Math.random() * 0.85,
    drift: -52 + Math.random() * 104,
    rotateStart: Math.random() * 140,
    rotateEnd: 540 + Math.random() * 560,
    scale: 0.75 + Math.random() * 0.55,
    opacity: 0.58 + Math.random() * 0.35,
  }));
}

export function playDailyRewardSound(power = 1) {
  try {
    if (typeof window === 'undefined') return;
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;

    if (!rewardAudioContext || rewardAudioContext.state === 'closed') {
      rewardAudioContext = new AC();
    }
    if (rewardAudioContext.state === 'suspended') {
      rewardAudioContext.resume();
    }

    const ctx = rewardAudioContext;
    const start = ctx.currentTime + 0.01;
    const intensity = Math.max(0.7, Math.min(1.5, power));

    const makeTone = (freq, duration, timeOffset, gain, type = 'sine') => {
      const osc = ctx.createOscillator();
      const g = ctx.createGain();
      osc.type = type;
      osc.frequency.setValueAtTime(freq, start + timeOffset);
      g.gain.setValueAtTime(Math.max(0.0001, gain), start + timeOffset);
      g.gain.exponentialRampToValueAtTime(0.0001, start + timeOffset + duration);
      osc.connect(g);
      g.connect(ctx.destination);
      osc.start(start + timeOffset);
      osc.stop(start + timeOffset + duration);
    };

    makeTone(640 * intensity, 0.09, 0, 0.1, 'triangle');
    makeTone(920 * intensity, 0.11, 0.08, 0.085, 'sine');
    makeTone(1220 * intensity, 0.2, 0.16, 0.08, 'sine');
    makeTone(1780 * intensity, 0.04, 0.07, 0.04, 'square');
    makeTone(1960 * intensity, 0.03, 0.14, 0.03, 'square');
  } catch {
    // ignore audio errors (browser policy / unsupported)
  }
}

export const DEFAULT_REWARD_COIN_SRC = `${process.env.PUBLIC_URL || ''}/fiski.png`;

/**
 * @param {{ burst: { id: string, particles: ReturnType<typeof createCoinParticles> } | null, coinSrc?: string }} props
 */
export function CoinRainOverlay({ burst, coinSrc = DEFAULT_REWARD_COIN_SRC }) {
  if (!burst) return null;

  return (
    <>
      <style>{`
        @keyframes daily-coin-fall {
          0% {
            transform: translate3d(0, -8vh, 0) rotate(var(--coin-rot-start)) scale(0.85);
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          100% {
            transform: translate3d(var(--coin-drift), 108vh, 0) rotate(var(--coin-rot-end)) scale(1.08);
            opacity: 0;
          }
        }
      `}</style>
      <div className="pointer-events-none fixed inset-0 z-[140] overflow-hidden" aria-hidden>
        {burst.particles.map((p) => (
          <div
            key={p.id}
            className="absolute top-[-10%] animate-[daily-coin-fall_linear_forwards]"
            style={{
              left: `${p.left}%`,
              animationDelay: `${p.delay}s`,
              animationDuration: `${p.duration}s`,
              '--coin-drift': `${p.drift}px`,
              '--coin-rot-start': `${p.rotateStart}deg`,
              '--coin-rot-end': `${p.rotateEnd}deg`,
            }}
          >
            <img
              src={coinSrc}
              alt=""
              width={24}
              height={24}
              className="h-6 w-6 object-contain drop-shadow-[0_3px_8px_rgba(0,0,0,0.45)]"
              style={{ opacity: p.opacity, transform: `scale(${p.scale})` }}
              draggable={false}
            />
          </div>
        ))}
      </div>
    </>
  );
}
